import { roundUpToTwoDecimalPlaces } from "@domains/utils/numberMethods";
export const DpInterestChargesMapper = (response) => {
    if (response)
        return response.map((x) => {
            return {
                monthYear: x.monthYear,
                interestAmount: roundUpToTwoDecimalPlaces(Number(x.interestAmount)),
                mtf: x.mtf,
            };
        });
    return [];
};
